module.exports = __webpack_public_path__ + "img/hero-lg.aecfbc3e.png";